import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import AccessoiresData from "../../../../../api/OtherAccessoiresData";
import BlogSidebar from "./BlogSidebar";
import SliderImage from "./SliderImage/SliderImage";

const BlogList = () => {
  const [selectedAccesoire, setSelectedAccesoire] = useState({});

  const { accesoireId } = useParams();

  useEffect(() => {
    // find the selected equipment
    const index = AccessoiresData.findIndex(
      (acc) => acc.id.toString() === accesoireId
    );
    if (index !== -1) {
      setSelectedAccesoire(AccessoiresData[index]);
    }
  }, [accesoireId]);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="wpo-blog-pg-section section-padding">
      <div className="container">
        <div className="row">
          <BlogSidebar selectedAccesoire={selectedAccesoire} />
          <div className={`col col-lg-8 col-12 order-lg-2`}>
            <div className="wpo-blog-content">
              {selectedAccesoire.articles &&
                selectedAccesoire.articles.map((article) => (
                  <div className={`post`} key={article.id}>
                    <div className="entry-details">
                      <h3 className="accesoires-article-name">
                        <Link
                          onClick={ClickHandler}
                          to={`/blog-single/${article.id}`}
                        >
                          {article.name}
                        </Link>
                      </h3>
                      <p className="accesoires-article-description">
                        {article.description1}
                      </p>
                    </div>
                    <div className="images_box" >

                      {article.image[2] ?

                        <>
                          <div
                            className="accesoires-article-image-container entry-media video-holder"
                            style={{ marginBottom: "1rem" }}
                          >
                            <img src={article.image[0]} alt="" />
                          </div>

                          <div className="display_images">

                            {article.image.map((image, index) => (

                              <>
                                {index === 0 ?
                                  <></>
                                  :

                                  <img className="side_images" src={image} alt="" />
                                }
                              </>
                            ))}
                          </div>
                          {/* <SliderImage data={article.image} /> */}
                        </>

                        :
                        <>
                          <div
                            className="accesoires-article-image-container entry-media video-holder"
                            style={{ marginBottom: "1rem" }}
                          >
                            <img src={article.image} alt="" />
                          </div>
                        </>

                      }
                    </div>
                    <a
                      href={article.brochure}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-style22"
                    >
                      {"Télécharger Brochure"}
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
